module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_68-e679b1fb82e19e4bf85e53ef00bc04a6.png";